// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"288":"2203a71b","361":"2ad11e2d","583":"e10952a6","760":"ea73f878","832":"7e5a3a5c","940":"3716079b","963":"6f7bb73c"}[chunkId] + ".chunk.js";
};